import React from 'react'
import exact from 'prop-types-exact'
import { HumanIcon } from 'components/icons'

const propTypes = {}

const defaultProps = {}

function LookingForArtistIndicator() {
  return (
    <div className="flex-horizontal looking-for-artist">
      <div className="human-icon">
        <HumanIcon aria-hidden />
      </div>
      <p>
        <strong>Looking for Teaching Artists</strong>
      </p>
    </div>
  )
}

LookingForArtistIndicator.propTypes = exact(propTypes)
LookingForArtistIndicator.defaultProps = defaultProps

export default React.memo(LookingForArtistIndicator)
